module.exports = __webpack_public_path__ + "img/second.2e118603.jpg";